import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class EventService {

    
    private applicationId:any;
    private previewMode:boolean = false;
    private loggedInUserRole ='';
    private allowEditing : boolean = false;
    constructor(private http: HttpClient) { }

    getEvents() {
        return this.http.get<any>('assets/demo/data/scheduleevents.json')
            .toPromise()
            .then(res => res.data as any[])
            .then(data => data);
    }

    setApplicationId(appId:any)
    {
        this.applicationId = appId;
    }

    getApplicationId()
    {
        return this.applicationId;
    }

    previewModeForApplication()
    {
        this.previewMode = true;
        return this.previewMode;
    }

    loggedInUser(user :any)
    {
    this.loggedInUser= user;
    }
    getLoggedInUser()
    {
        return this.loggedInUser;
    }
    AllowEdit(allow:boolean)
    {
        if(allow == true)
            {
               return this.allowEditing = true;
            }
            else
            {
              return  this.allowEditing = false;
            }
    }

    IseditAllowed()
    {
        return this.allowEditing;
    }







    
}
